import { ServiceOrigin } from "./runtime-enums";

export const resolveFirebaseFunctionName = (name: string, functionsOrigin = process.config.FUNCTIONS_ORIGIN): string => {
  return functionsOrigin === ServiceOrigin.Emulator ? name.replace("-temp-", "-") : name;
};
